export default "__VITE_ASSET__Cgm8QbS7__"